(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["op-collections-directory"] && !Shopify.designMode) return;
  try {
    
  function setupCatalogue(scope) {
    scope.querySelectorAll('.op-cat__directory').forEach((directory) => {
      if (location.hash === '#indice-collezioni') directory.open = true;
      const control = directory.querySelector('[data-filter-control]');
      if (!control || !control.hidden) return;
      const input = control.querySelector('input');
      const status = directory.querySelector('[data-status]');
      const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\b(?:bbq|barbeque)\b/g, 'barbecue').replace(/\bdocc(?:e|ia)\b/g, 'docc').replace(/[^a-z0-9]+/g, ' ').trim();
      const entries = Array.from(directory.querySelectorAll('[data-handle]'), (link) => ({
        row: link.parentElement,
        keywords: normalize(link.textContent + ' ' + link.dataset.handle),
      }));
      const filter = () => {
        const terms = normalize(input.value).split(' ').filter(Boolean).map((term) => term.length > 3 ? term.replace(/[aeio]$/, '') : term);
        let found = 0;
        entries.forEach(({row, keywords}) => {
          row.hidden = !terms.every((term) => keywords.includes(term));
          if (!row.hidden) found++;
        });
        status.textContent = terms.length ? (found ? status.dataset.results + ' ' + found : status.dataset.empty) : '';
      };
      input.addEventListener('input', filter);
      control.hidden = false;
    });
  }
  setupCatalogue(document);
  document.addEventListener('shopify:section:load', (event) => setupCatalogue(event.target));

  } catch(e) { console.error(e); }
})();
})();
